import React, { useContext } from 'react'
import { Product } from '../../Models/Product'
import Flag from 'react-world-flags'
import "./ProductCardAdmin.css"
import { Button, Tag } from 'antd'
import { DeleteOutlined, GlobalOutlined, ShoppingCartOutlined } from '@ant-design/icons'
import { PromiseSesionContext } from '../../Machines/ErrorMachine'
import { Monitor } from '../../Models/Monitor'
import { addMonitor } from '../../Api/Monitor'

interface Props{
    producto:Product
    type: "soon" | "disponibles"
}

const ProductCardAdmin = ({producto, type}:Props) => {
    const {cart, sendCart} = useContext(PromiseSesionContext);
    const {error, sendError} = useContext(PromiseSesionContext);

    const addCart = ()=>{

      sendCart({type: "ADD", data:{producto:producto}})
      sendError({type: "ERROR", data:{message:`${producto.name} agregada al carrito`, type:"info"}})

    }
  const isCreatedWithinAWeek = (dateString: string): boolean=> {
  // 1. Convertir la cadena de fecha a un objeto Date
  const createdAt = new Date(dateString);

  // 2. Obtener la fecha y hora actual
  const now = new Date();

  // 3. Calcular la diferencia en milisegundos
  const diffInMilliseconds = now.getTime() - createdAt.getTime();

  // 4. Definir una semana en milisegundos
  const oneWeekInMilliseconds = 7 * 24 * 60 * 60 * 1000;

  // 5. Comparar la diferencia con una semana
  return diffInMilliseconds < oneWeekInMilliseconds;
  }
  
        const sendMonitor = async ()=>{
            try{let user:string= localStorage.getItem("user") || ""
  
            let monitor:Monitor={
                action:`Agrego al carrito: ${producto.name}`,
                user:user
            }
            await addMonitor(monitor)}
            catch(error){}
        }
        
  return (
    <div className='ProductCardAdmin-component'>
      <div className='ProductCardAdmin-left'>
          <div className='ProductCardAdmin-left-image'>
            <img src={producto.image} />
          </div>
      </div>

      <div className='ProductCardAdmin-rigth'>
        <div className='ProductCardAdmin-rigth-header'>
          <span>{producto.name}</span>
          <div className='ProductCardAdmin-rigth-headerDetail'>
            <GlobalOutlined />
            {producto.language}
          </div>
        </div>

        <div className='ProductCardAdmin-rigth-category'>
          <div className='ProductCardAdmin-rigth-categoryItem'>
            <span>Category</span>
            <div>

            </div>
          </div>
        </div>

        <div className='ProductCardAdmin-rigth-prices'>
          <div className='ProductCardAdmin-rigth-prices-item ProductCardAdmin-rigth-prices-bcv'>
            <span>BCV</span>
            <span>${producto.price}</span>
          </div>

          <div className='ProductCardAdmin-rigth-prices-item ProductCardAdmin-rigth-prices-cash'>
            <span>Divisas</span>
            <span>${producto.cash_price}</span>
          </div>

        </div>

        <div className='ProductCardAdmin-rigth-actions'>
          <Button type='primary'>Agregar al carrito</Button>

          <Button type='default'>Editar</Button>
          <Button type='default'><DeleteOutlined /></Button>

        </div>
      </div>
    </div>
  )
}

export default ProductCardAdmin